import { createMuiTheme, MuiThemeProvider, Typography, withStyles, Tooltip, TableCell, Snackbar, Switch } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useEffect, useReducer, useState } from "react";
import Loader from "react-loader-spinner";
import editIcon from '../../assets/1@3x.png';
import api from "../api";
import MuiAlert from '@material-ui/lab/Alert';
import CloseImage from '../../assets/ic_close.png';
import { useHistory } from "react-router";
import Constant from "../../library/Constant";


const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const style = {
    position: "sticky",
    zIndex: 110
};

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function MonitorResep(props) {
    const history = useHistory()
    const [dataTable, setDataTable] = useState([])
    const [id, setID] = useState("")
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);

    useEffect(() => {
        getDataTable()
    }, [])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getDataTable = () => {
        api.create().getRecipe().then(response => {
            console.log(response);
            let data = response.data.data.map((item, index) => {
                return [
                    index + 1,
                    item.patient,
                    item.doctor,
                    item.transaction_code_client,
                    item.payment_option,
                    item.queue_no,
                    item.pharmacy_location,
                    item.id,
                ]
            })
            setDataTable(data)
        })
    }

    const handleDetail = ({ rowData }) => {
        history.push({
            pathname: '/farmasi/detail-resep',
            name: 'Detail Monitoring Resep',
            search: '',  // query string
            state: {  // location state
                id: rowData
            },
        })
    }

    const changeStatus = () => {
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    const columns = [
        {
            name: "No",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            label: "Nama Pasien",
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: "",
            label: "Nama Dokter",
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: "",
            label: "Kode Transaksi",
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: "",
            label: "Opsi Pembayaran",
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: "",
            label: "Nomor Antrian",
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: "",
            label: "Lokasi Farmasi",
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: "Aksi",
            options: {
                sort: false,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <LightTooltip title={"Detail"} arrow>
                                <button
                                    onClick={() => {
                                        handleDetail(tableMeta)
                                    }}
                                    style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent'
                                    }}>
                                    <img src={editIcon} style={{ width: 30, height: 30 }} />
                                </button>
                            </LightTooltip>
                        </div>
                    )
                }
            }
        }
    ];


    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div >
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={dataTable}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>
        </div>
    )
}